// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.chart[data-v-595be435] {
  max-width: 70px;
  position: relative;
  vertical-align: bottom;
  display: inline-block;
  top: 5px;
}
.chart-top-info[data-v-595be435] {
  top: -15px;
  float: right;
}
.chart-line[data-v-595be435] {
  width: 100%;
  margin-top: 20px;
  max-height: 100px;
  position: relative;
}
.chart-line canvas[data-v-595be435] {
  max-height: 100px;
}
.chart-line .chartjs-render-monitor[data-v-595be435] {
  width: 100% !important;
}
.chart-pie[data-v-595be435] {
  width: 100% !important;
}
@media only screen and (max-width: 1683px) {
.chart[data-v-595be435] {
    max-width: 65px;
}
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
